import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from '@angular/core';
import { Validators } from '@angular/forms';

import { finalize, map } from 'rxjs/operators';

import {
  Observable,
  merge,
  of,
} from 'rxjs';


import { CustomValidators } from '../../../../../common/custom-validation/custom-validators';
import { InternetbankAppApplicationException } from '../../../../../common/exceptions/exceptions';
import { FieldOptions } from '../../../../../ui/controls/field.model';
import { SelectItem } from '../../../../../ui/controls/select-field/select-item';
import { CustomFormControl } from '../../../../../ui/custom-reactive-forms/custom-form-control';
import { CustomFormGroup } from '../../../../../ui/custom-reactive-forms/custom-form-group';
import { PaymentTypeEnum } from '../../../transfers/budget-transfer-search/budget-transfer-search.service';
import { DocumentTypes } from '../payment-widgets.service';
import { ChargeForWidget } from '../shared/charge-item/change-item-entites';
import { WidgetBaseDirective } from '../shared/widget-base-component';

import { PaymentWidgetData } from './../payment-widget-data';

@Component({
	selector: 'app-widget-tax',
	templateUrl: './widget-tax.component.html',
	styleUrls: ['./widget-tax.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class WidgetTaxComponent extends WidgetBaseDirective implements OnInit {

	public PaymentTypeTaxPay = PaymentTypeEnum.TAX_PAY;

	public ngOnInit(): void {
		this.searchForm = new CustomFormGroup({
			typeSelect: new CustomFormControl(
				new FieldOptions({
					'@type': 'select-field',
					name: 'typeSelect',
					items: [
						new SelectItem(
							'Индекс налогового документа',
							DocumentTypes.UIN,
						),
						new SelectItem('ИНН', DocumentTypes.INN),
					],
				}),
			),
			searchText: new CustomFormControl(
				new FieldOptions({
					'@type': 'text-field',
					name: 'searchText',
					required: true,
				}),
			),
		});

		const typeSelectControl: CustomFormControl | null = this.searchForm.getControlFromAllLevels('typeSelect');
		const searchTextControl: CustomFormControl | null = this.searchForm.getControlFromAllLevels('searchText');

		typeSelectControl?.valueChanges
			.subscribe((documentType: DocumentTypes) => {
				searchTextControl?.setValue(null, {
					onlySelf: true,
					emitEvent: false,
				});

				switch (documentType) {
					case DocumentTypes.UIN: {
						// searchTextControl.fieldOptions.placeholder = 'ИНД';
						if (searchTextControl) {
							searchTextControl.fieldOptions.hints = {underLineHint: '20 или 25 цифр'};
							searchTextControl.fieldOptions.inputMask = {
								mask: '9{20,25}',
								autoUnmask: true,
								showMaskOnFocus: true,
								showMaskOnHover: false,
							};
							searchTextControl.fieldOptions.inputMode = 'numeric';
							searchTextControl.setValidators([
								Validators.required,
								CustomValidators.uinLength(),
								CustomValidators.uin(),
							]);
						}
						break;
					}
					case DocumentTypes.INN: {
						if (searchTextControl) {
							// searchTextControl.fieldOptions.placeholder = 'ИНН';
							searchTextControl.fieldOptions.hints = {underLineHint: '12 цифр'};
							searchTextControl.fieldOptions.inputMask = {
								mask: '9{0,12}',
								autoUnmask: true,
								showMaskOnFocus: false,
								showMaskOnHover: false,
								placeholder: '',
							};
							searchTextControl.fieldOptions.inputMode = 'numeric';
							searchTextControl.setValidators([
								Validators.required,
								CustomValidators.inn(),
								CustomValidators.patternWithMessage(
									/^.{12}$/,
									'Значение должно содержать 12&nbsp;символов',
								),
								CustomValidators.patternWithMessage(
									/^[0-9]*$/,
									'Введено некорректное значение',
								),
							]);
						}
						break;
					}
				}

				searchTextControl?.updateValueAndValidity({emitEvent: false});
			});

		merge(
			typeSelectControl?.valueChanges || of(undefined),
			searchTextControl?.valueChanges || of(undefined),
		)
			.subscribe(() => {
				this.chargeWidget.searcErrors = null;
				searchTextControl?.markAsPristine();
				this.charges = [];
			});

		typeSelectControl
			?.onTemplateControlInit
			.subscribe(() => {
				typeSelectControl.setValue(typeSelectControl.fieldOptions.items?.[0].value);
			});

		this.onTabSubscriptionActivate();
	}

	public onTabSubscriptionActivate(): void {
		this.paymentWidgetsServiceService
			.getTaxOnSubscription()
			.pipe(
				finalize(() => {
					this.changeDetectorRef.markForCheck();
				}),
			)
			.subscribe(
				(data: PaymentWidgetData) => {
					this.charges = data.accruals;
					this.subscriptionsAbsence = data.subscriptionsAbsence;
				},
				(error: InternetbankAppApplicationException) => {
					this.chargeWidget.searcErrors = error.errors || null;
				});
	}
	public onTabSearchActivate(): void {
	}
	public search(): void {

		this.chargeWidget.searcErrors = null;

		const typeSelectControl: CustomFormControl | null = this.searchForm.getControlFromAllLevels(
			'typeSelect',
		);
		const searchTextControl: CustomFormControl | null = this.searchForm.getControlFromAllLevels(
			'searchText',
		);

		if (searchTextControl?.invalid) {
			return;
		}

		this.chargeWidget.startSearch();

		let search$: Observable<Array<ChargeForWidget>> | undefined;
		switch (typeSelectControl?.value) {
			case DocumentTypes.UIN:
				search$ = this.paymentWidgetsServiceService
					.searchOnUin(searchTextControl?.value)
					.pipe(map((data: ChargeForWidget) => (data ? [data] : [])));
				break;
			case DocumentTypes.INN:
				search$ = this.paymentWidgetsServiceService.searchOnDocument(
					typeSelectControl.value,
					searchTextControl?.value,
				);
				break;

			default:
				break;
		}
		if (search$) {
			search$
				.pipe(
					finalize(() => {
						this.chargeWidget.stopSearch();
						this.changeDetectorRef.markForCheck();
					}),
				)
				.subscribe(
					(data: Array<ChargeForWidget>) => {
						this.charges = data;
					},
					(error: InternetbankAppApplicationException) => {
						this.chargeWidget.searcErrors = error.errors || null;
					});
		}

	}

	public handleKeyDown(event: KeyboardEvent): void {
		if (event.keyCode === 13) {
			// 'enter' pressed
			this.search();
		}
	}
}
